<script>
import BackgroundHalfCircle from '@/components/BackgroundHalfCircle'
import EnvironmentUtils from '@/utils/environmentUtils'
import ServicesUtils from '@/utils/servicesUtils'

export default
{
    name: 'city-info',

    created ()
    {
        this.cityId = EnvironmentUtils.cityId
        this.cityName = EnvironmentUtils.cityName
    },

    render ()
    {
        return (
            <div id='whole'>
                <BackgroundHalfCircle settings-mobile={{ height: '70vw' }} settings-tablet={{ height: '35vh' }} settings-desktop={{ height: '10vh' }} />
                <div id='content'>
                    <img id='city-avatar' src={`${ServicesUtils.cdnUrl}/find/cities/${this.cityId}/city-icon`} />
                    <span id='city-title'>{ this.cityName }</span>
                    <br />
                    <p id='weather-temperature'>
                        <img id='forecast-icon' src={this.weatherIcons[this.cityWeather.description]} />
                        <p>{this.cityWeather.temperature} °C</p>
                    </p>
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            cityId: null,
            cityName: null,
            weatherIcons:
            {
                'thunderstorm': require('@/assets/img/thunderstorm.svg'),
                'drizzle': require('@/assets/img/clouds.svg'),
                'rain': require('@/assets/img/rain.svg'),
                'snow': require('@/assets/img/snow.svg'),
                'mist': require('@/assets/img/clouds.svg'),
                'smoke': require('@/assets/img/clouds.svg'),
                'haze': require('@/assets/img/clouds.svg'),
                'dust': require('@/assets/img/clouds.svg'),
                'fog': require('@/assets/img/clouds.svg'),
                'sand': require('@/assets/img/clouds.svg'),
                'ash': require('@/assets/img/clouds.svg'),
                'squall': require('@/assets/img/clouds.svg'),
                'tornado': require('@/assets/img/clouds.svg'),
                'clear': require('@/assets/img/sun.svg'),
                'clouds': require('@/assets/img/clouds.svg')
            }
        }
    },

    computed:
    {
        cityWeather ()
        {
            return this.$store.state.weather.cityWeather
        }
    },

    methods:
    {
    },

    components:
    {
        BackgroundHalfCircle
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#whole
{
    position: absolute;
    top: 0;
    left: 0;
}

#content
{
    margin-top: 8vh;
    margin-left: 4vw;
    margin-right: 4vw;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4), 1px 0px 1px rgba(0, 0, 0, 0.2);

    .OnDesktop({
        @margin: calc(var(--theme-vertical-menu-total-vertical-space) + 4vw);

        margin-left: @margin;
        margin-right: @margin;

        margin-bottom: 0;
        padding-bottom: 5vw;
    });
}

#city-avatar
{
    .WidthHeight(45px);
    vertical-align: bottom;
}

#city-title
{
    color: white;
    font-family: Nunito;
    font-weight: bold;
    font-size: 35px;
    margin-left: 10px;
}

#weather-temperature
{
    display: flex;
    align-items: center;
    margin-top: 2vh;
    font-size: 17px;

    p
    {
        margin-left: 15px;
        margin-top: 5px;
        color: white;
    }
}

#forecast-icon
{
    .WidthHeight(35px);
    margin-bottom: -3px;
    margin-left: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/CityInfo.vue